import { createClient, type SupabaseClient } from '@supabase/supabase-js'

// ORIGINE DYNAMIQUE, pas une URL figée. FlashCP est SERVI ET INTERROGÉ sur le
// même hôte : nginx route /rest,/auth,/storage,/realtime vers Kong sur l'origine
// courante. On dérive donc l'URL Supabase de LÀ OÙ la page est réellement servie,
// au lieu de coder « sotcp.aslak.eu » en dur dans le bundle.
//
// Conséquence directe : le MÊME build marche partout — via le tunnel
// (https://sotcp.aslak.eu), mais aussi par IP tailnet/LAN en http quand le
// domaine est bloqué (Netskope & co.). Un seul artefact, n'importe quel hôte.
// L'ancienne valeur d'env reste un filet pour un contexte sans window (build/SSR).
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined
const url = typeof window !== 'undefined' && window.location?.origin
  ? window.location.origin
  : (import.meta.env.VITE_SUPABASE_URL as string | undefined)

if (!url || !anon) {
  throw new Error(
    'VITE_SUPABASE_ANON_KEY est requis (l’URL vient de l’origine) — voir .env.example',
  )
}

// @supabase/auth-js sérialise ses opérations de jeton avec l'API Web Locks.
// Dans certaines WebView Android (bornes Honeywell / kiosque), ce verrou ne se
// libère jamais et la connexion reste bloquée sur « Connexion… ». FlashCP est
// mono-onglet : la sérialisation inter-contexte n'est pas nécessaire. Reprise
// telle quelle de la V2 (src/lib/supabase/client.js).
const noopLock = async <T,>(_nom: string, _timeout: number, fn: () => Promise<T>) => fn()

export const supabase: SupabaseClient = createClient(url, anon, {
  auth: {
    lock: noopLock,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'flashcp-auth',
  },
  realtime: { params: { eventsPerSecond: 5 } },
})
